export default __webpack_public_path__ + "static/media/aaa-logo.36f0e3ed.png";